import { render, staticRenderFns } from "./depositPromoConfirmModal.vue?vue&type=template&id=59f5e987"
import script from "./depositPromoConfirmModal.vue?vue&type=script&lang=js"
export * from "./depositPromoConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports